var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWiFi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_x32_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#374151;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M439.713,187.302c-9.487,0-17.172,7.696-17.172,17.18c0,9.483,7.686,17.166,17.172,17.166 c9.484,0,17.173-7.682,17.173-17.166C456.886,194.998,449.197,187.302,439.713,187.302z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 424.137,
    y: 228.04,
    className: "st0",
    width: 31.152,
    height: 81.47
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "309.383,196.09 309.383,227.242 309.383,309.511 339.368,309.511 339.368,274.906 397.03,274.906  397.03,247.212 339.368,247.212 339.368,227.242 405.232,227.242 405.232,196.09 339.368,196.09  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M431.85,143.378H80.15c-44.266,0-80.15,35.88-80.15,80.146v64.946c0,44.265,35.884,80.153,80.15,80.153h351.7 c44.266,0,80.15-35.888,80.15-80.153v-64.946C512,179.258,476.116,143.378,431.85,143.378z M154.217,310.111h-28.232 l-12.741-55.257l-12.741,55.257H72.27L44.269,196.09h32.875l10.374,50.632l12.174-50.632h27.1l12.178,50.632l10.371-50.632h32.876 L154.217,310.111z M226.047,309.511h-31.153v-81.47h31.153V309.511z M210.47,221.648c-9.484,0-17.173-7.682-17.173-17.166 c0-9.484,7.689-17.18,17.173-17.18c9.487,0,17.173,7.696,17.173,17.18C227.643,213.965,219.957,221.648,210.47,221.648z  M494.428,288.47c0,34.509-28.075,62.578-62.578,62.578H234.834c0,0,34.345-23.962,34.345-69.094c0-45.125,0-52.173,0-52.173 c0-38.016,30.818-68.834,68.831-68.834h93.839c34.503,0,62.578,28.076,62.578,62.578V288.47z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWiFi);
export default __webpack_public_path__ + "static/media/wi-fi.3378d2c017e015d34d5d6aa45e3954c7.svg";
export { ForwardRef as ReactComponent };